
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.newsletter {background-color: var(--tint-dark-blue);padding-left: 1.5rem;padding-right: 1.5rem;padding-top: 2.5rem;padding-bottom: 0.5rem
}@media (min-width: 768px) {.newsletter {padding-top: 3.5rem
    }.newsletter {padding-bottom: 1.5rem
    }
}@media (min-width: 1024px) {.newsletter {padding-left: 2.5rem;padding-right: 2.5rem
    }.newsletter {padding-top: 5rem
    }.newsletter {padding-bottom: 3rem
    }
}.newsletter--centered .container {max-width: 42rem
}.newsletter--has-footer {padding-bottom: 2.5rem
}@media (min-width: 768px) {.newsletter--has-footer {padding-bottom: 3.5rem
    }
}@media (min-width: 1024px) {.newsletter--has-footer {padding-bottom: 5rem
    }
}

.container {margin-left: auto;margin-right: auto;margin-top: 0px;margin-bottom: 0px;max-width: 72rem
}

.title {margin-bottom: 2rem;text-align: center;color: var(--primary-blue-dark)
}

.line {margin-bottom: 2rem;height: 0px;max-width: 64rem;border-bottom-width: 1px;border-left-width: 0px;border-right-width: 0px;border-top-width: 0px;border-style: solid;border-color: var(--neutral-gray-4);outline: 2px solid transparent;outline-offset: 2px
}

::slotted([slot='footer']) {display: flex;flex-direction: column;align-items: center;justify-content: center;gap: 1.5rem
}

@media (min-width: 768px) {::slotted([slot='footer']) {flex-direction: row
    }
}
`;